module.exports = __webpack_public_path__ + "img/Workflows.529854e7.svg";